import { render } from "./NewFitnesExView.vue?vue&type=template&id=bfbeb468&scoped=true"
import script from "./NewFitnesExView.vue?vue&type=script&lang=js"
export * from "./NewFitnesExView.vue?vue&type=script&lang=js"

import "./NewFitnesExView.vue?vue&type=style&index=0&id=bfbeb468&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_b828ca3935601f9354f53de73adb2d35/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfbeb468"]])

export default __exports__